// @flow
import { createContext } from 'react';

export const YearSelectionContext = createContext({});
